import type { HTMLChakraProps } from '@chakra-ui/react';
import { chakra, createListCollection, Grid, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import type { PaginationParams } from './types';
import useApiQuery from 'lib/api/useApiQuery';
import { Pagination as Pag } from 'toolkit/chakra/pagination';
import type { SelectOption } from 'toolkit/chakra/select';
import { Select } from 'toolkit/chakra/select';

const limitRange = [ ...Array(51).keys() ].map(item => ({ label: item.toString(), value: item.toString() })).sort((a, b) => a < b ? 1 : -1);

interface Props extends PaginationParams, Omit<HTMLChakraProps<'div'>, 'page' | 'direction'> {
  totalTransactions?: string;
}

const Pagination = (props: Props) => {
  const { page, onNextPageClick, onPrevPageClick, resetPage, hasPages, hasNextPage, canGoBackwards, isLoading, isVisible, ...rest } = props;

  const statsQuery = useApiQuery('general:stats', {
    queryOptions: {
      refetchOnMount: false,
    },
  });

  const totalTransactions = statsQuery?.data?.total_transactions;

  if (!isVisible) {
    return null;
  }

  return (
    <Grid
      gridTemplateColumns="auto auto auto"
      justifyItems="center"
      templateAreas={{
        lg: `"transactions pag select"`,
        base:
          `"pag pag pag"
          "transactions . select"
          `,
      }}
      rowGap={ 3 }
      justifyContent="space-between"
      as="nav"
      position="sticky"
      background={{ _light: 'defaultBlack.50', _dark: 'black' }}
      bottom={ 0 }
      py={ 2 }
      px={ 7 }
      mx={ -1 }
      textStyle="sm"
      { ...rest }
    >
      <GridItem area="transactions" display="flex" alignItems="center" gap={ 1 }>
        { totalTransactions && Number(totalTransactions).toLocaleString() }
        <chakra.span hideBelow="lg">transactions</chakra.span>
        <chakra.span hideFrom="lg">txns</chakra.span>
      </GridItem>
      <GridItem area="pag">
        <Pag { ...props }/>
      </GridItem>
      <GridItem area="select" display="flex" alignItems="center" gap={ 2 }>
        <Text color="text.pale">Show</Text>
        <Select collection={ createListCollection <SelectOption>({ items: limitRange }) } placeholder="50"/>
      </GridItem>
    </Grid>
  );
};

export default React.memo(Pagination);
